export default "__VITE_ASSET__Yl2E2OD2__"